/** Navegación POST para que Safari reciba el .pkpass y abra Wallet.
 * El permiso breve no entra en URLs, almacenamiento ni registros del proxy.
 */
export function abrirAppleWallet(url: string, ticket: string): void {
  const form = document.createElement('form');
  form.method = 'POST'; form.action = url; form.hidden = true;
  const input = document.createElement('input');
  input.type = 'hidden'; input.name = 'ticket'; input.value = ticket;
  form.appendChild(input); document.body.appendChild(form);
  try { form.submit(); } finally { form.remove(); }
}
